import axios from 'axios';

// Configuração do axios com URL base e timeout
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  timeout: 8000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Interceptador para logging de requisições
api.interceptors.request.use(
  config => {
    console.log(`[API] Requisição para ${config.url}`, config);
    return config;
  },
  error => {
    console.error('[API] Erro na requisição:', error);
    return Promise.reject(error);
  }
);

// Interceptador para logging de respostas
api.interceptors.response.use(
  response => {
    console.log(`[API] Resposta de ${response.config.url}:`, response.data);
    return response;
  },
  error => {
    if (error.response) {
      // A requisição foi feita e o servidor respondeu com um código de status
      // que não está no intervalo de 2xx
      console.error('[API] Erro no servidor:', error.response.status, error.response.data);
    } else if (error.request) {
      // A requisição foi feita mas nenhuma resposta foi recebida
      console.error('[API] Erro de rede - sem resposta:', error.request);
    } else {
      // Algo aconteceu na configuração da requisição que gerou um erro
      console.error('[API] Erro na configuração da requisição:', error.message);
    }
    console.error('[API] Configuração completa do erro:', error.config);
    return Promise.reject(error);
  }
);

// Funções de API
const apiService = {
  // Produtos
  getProducts: async () => {
    try {
      const response = await api.get('/api/products');
      return response.data;
    } catch (error) {
      console.error('Falha ao obter produtos:', error);
      throw error;
    }
  },
  
  getProductById: async (id) => {
    try {
      const response = await api.get(`/api/products/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Falha ao obter produto com ID ${id}:`, error);
      throw error;
    }
  },
  
  // Teste de conexão
  testConnection: async () => {
    try {
      const response = await api.get('/api/health');
      return response.data;
    } catch (error) {
      console.error('Teste de conexão falhou:', error);
      throw error;
    }
  }
};

export default apiService; 